<!-- Cachebuster: 27 (used to clear cache on bit.dev, update if builds are not updated) -->
<template>
  <div id="fasttrack-crm">
    <Inbox v-if="enableInbox && integrationVersion >= 1.1" @inboxMounted="inboxMounted" :closeModalOnFogClick="inboxCloseModalOnFogClick" :locale="locale" :authToken="authToken" :fusionUrl="fusionUrl" :pusherKey="pusherKey" :userId="userId" :brandId="brandId" :brandName="brandName" :showInbox="showInbox" :translations="translations" :navBarLogo="inboxNavbarLogo" :termsAboveButtons="inboxTermsAboveButtons" :contactEmail="inboxContactEmail" :supportLink="inboxSupportLink" :supportLinkText="inboxSupportLinkText" :supportLinkOpenInNewTab="inboxSupportLinkOpenInNewTab" :pusherRegion="pusherRegion" @toggleInbox="toggleInbox" @unreadBadgeChanged="inboxUnreadBadgeChanged"></Inbox>
    <PendingBonusesV2 v-if="enablePendingBonusesV2 && integrationVersion >= 1.1" :selectedPendingBonusId="selectedPendingBonusId" :depositPageUrl="depositPageUrl" :closeModalOnFogClick="pendingBonusesV2CloseModalOnFogClick" :locale="locale" :authToken="authToken" :fusionUrl="fusionUrl" :prismaUrl="prismaUrl" :userId="userId" :brandId="brandId" :brandName="brandName" :showPendingBonusesV2="showPendingBonusesV2" :translations="translations" :navBarLogo="inboxNavbarLogo" :contactEmail="inboxContactEmail" @togglePendingBonusesV2="togglePendingBonusesV2" @badgeChanged="pendingBonusesV2BadgeChanged" :showTermsHeader="pendingBonusesShowTermsHeader"></PendingBonusesV2>
    <Notifications v-if="integrationVersion == 1.0" :authToken="authToken" :userId="userId" :brandId="brandId" :brandName="brandName" :pusherKey="pusherKey" :prismaUrl="prismaUrl" :fusionUrl="fusionUrl" :pusherRegion="pusherRegion" />
    <TrackEvents v-if="integrationVersion == 1.0 || enableEventTracking" :authToken="authToken" :userId="userId" :brandId="brandId" :brandName="brandName"></TrackEvents>
    <PendingRewards v-if="integrationVersion == 1.0 || enablePendingRewards" :authToken="authToken" :userId="userId" :brandId="brandId" :brandName="brandName" :prismaUrl="prismaUrl" :fusionUrl="fusionUrl" ref="pendingBonuses"></PendingRewards>
    <CRMIntegration v-if="integrationVersion == 1.0 || enableCrmIntegration" :jwtToken="jwtToken" :authToken="authToken" :userId="userId" :crmUrl="crmUrl" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as locales from 'date-fns/locale';
import Notifications from './components/Notifications.vue';
import TrackEvents from './components/TrackEvents.vue';
import PendingRewards from './components/PendingRewards.vue';
import CRMIntegration from './components/CRMIntegration.vue';
import Inbox from './components/Inbox/Inbox.vue';

import PendingBonusesV2 from './components/PendingBonusesV2/PendingBonusesV2.vue';

import { sendPrivateTestNotification } from './api/notifications';
import { mockMessage } from './utils/mockmessage';
import { logWarn, log } from './utils/log';
import { setMobileResponsive } from './utils/mobileResponsive';


export default {
  name: 'fasttrack-crm',
  data() {
    return {
      showInbox: false,
      showPendingBonusesV2: false,
      selectedPendingBonusId: null,

      // CONFIG FLAGS:
      integrationVersion: null,
      autoInit: null,

      enableInbox: null,
      enablePendingBonusesV2: null,
      enableEventTracking: null,
      enablePendingRewards: null,
      enableCrmIntegration: null,

      translations: {
        recieved: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.recieved) ? window.fasttrack.translations.recieved : 'Received:',
        validUntil: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.validUntil) ? window.fasttrack.translations.validUntil : 'Valid until:',
        questionsTop: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.questionsTop) ? window.fasttrack.translations.questionsTop : 'Questions? Mail us at',
        questionsShort: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.questionsShort) ? window.fasttrack.translations.questionsShort : 'Questions:',
        deleteMessagePrompt: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.deleteMessagePrompt) ? window.fasttrack.translations.deleteMessagePrompt : 'Are you sure you want to delete this message?',
        inboxEmpty: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.inboxEmpty) ? window.fasttrack.translations.inboxEmpty : 'There is currently no messages in your inbox',
        readMore: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.readMore) ? window.fasttrack.translations.readMore : 'Read more',
        backToList: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.backToList) ? window.fasttrack.translations.backToList : 'Back',
        inboxHeader: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.inboxHeader) ? window.fasttrack.translations.inboxHeader : 'Inbox',

        pendingBonusesEmpty: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesEmpty) ? window.fasttrack.translations.pendingBonusesEmpty : 'You currently have no pending bonuses',
        pendingBonusesTitle: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesTitle) ? window.fasttrack.translations.pendingBonusesTitle : 'Pending Bonuses',
        pendingBonusesSubTitle: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesSubTitle) ? window.fasttrack.translations.pendingBonusesSubTitle : 'Grab these cool bonuses!',
        pendingBonusesExpiresIn: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesExpiresIn) ? window.fasttrack.translations.pendingBonusesExpiresIn : 'Expires in',
        pendingBonusesExpires: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesExpires) ? window.fasttrack.translations.pendingBonusesExpires : 'Expires',
        pendingBonusesCTAUnlockText: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesCTAUnlockText) ? window.fasttrack.translations.pendingBonusesCTAUnlockText : 'Deposit!',
        pendingBonusesCTAClaimFallbackText: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesCTAClaimFallbackText) ? window.fasttrack.translations.pendingBonusesCTAClaimFallbackText : 'Claim',
        pendingBonusesBackButtonText: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesBackButtonText) ? window.fasttrack.translations.pendingBonusesBackButtonText : 'Back',
        pendingBonusesTermsAndConditionsHeader: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesTermsAndConditionsHeader) ? window.fasttrack.translations.pendingBonusesTermsAndConditionsHeader : 'Terms & Conditions',
        pendingBonusesBonusUnlockedText: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.pendingBonusesBonusUnlockedText) ? window.fasttrack.translations.pendingBonusesBonusUnlockedText : 'Awesome! You can now claim this offer below',

        days: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.days) ? window.fasttrack.translations.days : 'd',
        hours: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.hours) ? window.fasttrack.translations.hours : 'h',
        minutes: (window.fasttrack && window.fasttrack.translations && window.fasttrack.translations.minutes) ? window.fasttrack.translations.minutes : 'min',
      },

      // Enabling this one means that the front end side implementing this is gonna put a JWT token inside the window.sid.
      // This also then means we will use another endpoint of authenticating the user in fusion api.
      enableJWT: window.fasttrack && window.fasttrack.enableJWT ? window.fasttrack.enableJWT : false,
      tokenLocation: window.fasttrack && window.fasttrack.tokenLocation ? window.fasttrack.tokenLocation : '',


      inboxNavbarLogo: window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.navBarLogo ? window.fasttrack.inbox.navBarLogo : null,
      inboxContactEmail: window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.contactEmail ? window.fasttrack.inbox.contactEmail : 'info@example.com',
      inboxSupportLink: window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.supportLink ? window.fasttrack.inbox.supportLink : '',
      inboxSupportLinkText: window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.supportLinkText ? window.fasttrack.inbox.supportLinkText : 'Contact Support',
      inboxSupportLinkOpenInNewTab: window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.supportLinkInNewTab ? window.fasttrack.inbox.supportLinkInNewTab : false,
      locale: null,
      inboxTermsAboveButtons: (window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.termsAboveButtons) ? window.fasttrack.inbox.termsAboveButtons : false, // eslint-disable-line
      inboxCloseModalOnFogClick: (window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.closeModalOnFogClick) ? window.fasttrack.inbox.closeModalOnFogClick : false, // eslint-disable-line

      pendingBonusesShowTermsHeader: (window.fasttrack && window.fasttrack.pendingBonusesV2 && window.fasttrack.pendingBonusesV2.showTermsHeader) ? window.fasttrack.pendingBonusesV2.showTermsHeader : false, // eslint-disable-line
      pendingBonusesV2CloseModalOnFogClick: (window.fasttrack && window.fasttrack.pendingBonusesV2 && window.fasttrack.pendingBonusesV2.closeModalOnFogClick) ? window.fasttrack.pendingBonusesV2.closeModalOnFogClick : false, // eslint-disable-line
      depositPageUrl: (window.fasttrack && window.fasttrack.pendingBonusesV2 && window.fasttrack.pendingBonusesV2.depositPageUrl) ? window.fasttrack.pendingBonusesV2.depositPageUrl : '/deposit', // eslint-disable-line
      keepAliveTimer: null,
    };
  },
  components: {
    Notifications,
    TrackEvents,
    PendingRewards,
    CRMIntegration,
    Inbox,
    PendingBonusesV2,
  },
  computed: {
    ...mapGetters({
      authToken: 'authToken',
      userId: 'userId',
      brandId: 'brandId',
      pusherKey: 'pusherKey',
      brandName: 'brandName',
      prismaUrl: 'prismaUrl',
      fusionUrl: 'fusionUrl',
      pusherRegion: 'pusherRegion',
      crmUrl: 'crmUrl',
      jwtToken: 'jwtToken',
    }),
    inboxBadgeElement() {
      const badgeId = (window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.badgeId) ? window.fasttrack.inbox.badgeId : null;
      if (badgeId) {
        return document.querySelector(badgeId);
      }
      return null;
    },
    pendingBonusesV2BadgeElement() {
      const badgeId = (window.fasttrack && window.fasttrack.pendingBonusesV2 && window.fasttrack.pendingBonusesV2.badgeId) ? window.fasttrack.pendingBonusesV2.badgeId : null;
      if (badgeId) {
        return document.querySelector(badgeId);
      }
      return null;
    },
  },
  mounted() {
    this.setLocale();
    this.updateConfigVars();
    if (this.integrationVersion === 1.0 || this.autoInit) {
      this.init();
    }

    this.$nextTick(() => {
      if (window && window.dispatchEvent) {
        const event = new Event('fasttrack-crm-ready');
        window.dispatchEvent(event);
      }
    });

    setMobileResponsive(this.$store);
  },
  methods: {
    inboxMounted() {
      // Example of how the local notification will be sent:
      // const message = {
      //   Event: 'shoutout',
      //   Title: 'hejsan',
      //   Message: 'This is msg body!',
      //   FooterText: 'This is footer text!',
      //   ImageUrl: 'https://fawry.com/wp-content/uploads/2017/05/header-bg-1-1.png',
      //   CTAButtonText: 'Click here!',
      //   CTAButtonLink: 'https://www.google.com',
      //   CTAButton2Text: 'Click here!',
      //   CTAButton2Link: 'https://www.google.com',
      // };
      // this.sendLocalNotification(message);
    },
    sendLocalNotification(message) {
      const event = new CustomEvent('send-local-message', {
        detail: { ...message },
      });
      window.dispatchEvent(event);
    },
    updateConfigVars() {
      this.integrationVersion = (window.fasttrack && window.fasttrack.integrationVersion) ? window.fasttrack.integrationVersion : 1.0;
      this.autoInit = (window.fasttrack && window.fasttrack.autoInit) ? window.fasttrack.autoInit : (window.fasttrack && window.fasttrack.isProduction) ? window.fasttrack.isProduction : false; /* eslint-disable-line */
      this.enableInbox = (window.fasttrack && window.fasttrack.inbox && window.fasttrack.inbox.enable) ? window.fasttrack.inbox.enable : false; /* eslint-disable-line */
      this.enableEventTracking = (window.fasttrack && window.fasttrack.enableEventTracking) ? window.fasttrack.enableEventTracking : false; /* eslint-disable-line */
      this.enablePendingRewards = (window.fasttrack && window.fasttrack.enablePendingRewards) ? window.fasttrack.enablePendingRewards : false; /* eslint-disable-line */
      this.enableCrmIntegration = (window.fasttrack && window.fasttrack.enableCrmIntegration) ? window.fasttrack.enableCrmIntegration : false; /* eslint-disable-line */

      this.enablePendingBonusesV2 = (window.fasttrack && window.fasttrack.pendingBonusesV2 && window.fasttrack.pendingBonusesV2.enable) ? window.fasttrack.pendingBonusesV2.enable : false; /* eslint-disable-line */
    },
    setLocale() {
      if (window.fasttrack && window.fasttrack.locale && window.fasttrack.locale !== '' && locales[window.fasttrack.locale]) {
        this.locale = locales[window.fasttrack.locale];
      } else {
        const userLocale = (navigator && navigator.language) ? navigator.language.slice(0, 2) : null;
        this.locale = (userLocale && locales[userLocale]) ? locales[userLocale] : locales.enGB;
      }
    },
    init(sid = null, source = null) {
      if (sid && sid !== '') window.sid = sid;
      if (source && source !== '') window.source = source;

      if (this.enableJWT && this.tokenLocation !== '') {
        const location = this.tokenLocation.split('.');
        switch (location[0]) {
          case 'local_storage':
            if (location.length > 1) {
              window.sid = window.localStorage.getItem(location[1]);
            }
            break;
          default:
            console.error(`'${location[0]}' is not a supported token location, please use any of the following: ['local_storage'].`);
        }
      }

      const payload = {
        sid: window.sid,
        enableJWT: this.enableJWT,
      };

      if (window.source && window.source !== '') payload.source = window.source;

      this.updateConfigVars();
      if (!window.sid && process.env.NODE_ENV === 'production' && !this.enableJWT) {
        console.error('We didnt have an sid variable', window.sid);
        return;
      }

      const brandName = window.fasttrackbrand || 'metalcasino';

      this.$store.dispatch('setConfig', { brandName, enableJWT: this.enableJWT }).then(() => {
        this.$store.dispatch('authenticate', payload).then(() => {
          log('Successfully authenticated!');
          this.$nextTick(() => {
            if (window && window.dispatchEvent) {
              const event = new Event('fasttrack-crm-authed');
              window.dispatchEvent(event);
            }
          });
        }).catch((error) => {
          this.$store.dispatch('reset');
          logWarn(error);
        });
      });
    },
    logout() {
      this.$store.dispatch('reset');
    },
    inboxUnreadBadgeChanged(count) {
      const badgeElement = this.inboxBadgeElement;
      if (badgeElement) {
        badgeElement.innerHTML = count;
        if (count > 0) {
          badgeElement.style.display = 'block';
        } else {
          badgeElement.style.display = 'none';
        }
      }
    },
    pendingBonusesV2BadgeChanged(count) {
      const badgeElement = this.pendingBonusesV2BadgeElement;
      if (badgeElement) {
        badgeElement.innerHTML = count;
        if (count > 0) {
          badgeElement.style.display = 'block';
        } else {
          badgeElement.style.display = 'none';
        }
      }
    },
    toggleInbox() {
      if (this.integrationVersion === 1.0 || !this.enableInbox || !this.$children.find(child => child.$options.name === 'Inbox')) {
        logWarn('Inbox is not enabled!');
        return;
      }
      this.showInbox = !this.showInbox;
    },
    togglePendingBonusesV2(bonusId) {
      if (this.integrationVersion === 1.0 || !this.enableInbox || !this.$children.find(child => child.$options.name === 'PendingBonusesV2')) {
        logWarn('PendingBonusesV2 is not enabled!');
        return;
      }

      if (bonusId) {
        const event = new CustomEvent('set-selected-pending-bonus', {
          detail: { bonusId },
        });
        window.dispatchEvent(event);
      }

      this.showPendingBonusesV2 = !this.showPendingBonusesV2;
    },
    sendDemoMessage(params) {
      const mock = { ...mockMessage };
      const body = Object.assign({}, mock, params);
      sendPrivateTestNotification(this.fusionUrl, this.authToken, body)
        .then((response) => {
          if (response.data && response.data.Success) return;

          if (response.data.Errors && response.data.Errors.length > 0) {
            response.data.Errors.forEach((error, index) => {
              logWarn(`Error ${index}: ${error.Message}`);
            });
            return;
          }
          logWarn('Could not send demo message!');
        }).catch((error) => {
          logWarn('Could not sent demo message', error);
        });
    },
  },
};
</script>

<style lang="less">
#fasttrack-crm {
  .cta-button {
    font-family: "Lato", sans-serif;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
    background-color: #0e9543;
    color: white;
    border-radius: 4px;
    box-shadow: -2px -2px 0px inset rgba(0, 0, 0, 0.3);
    display: inline-block;
    padding: 15px 15px;
    margin-bottom: 10px;
    text-decoration: none;
    outline: none;
    border: 0;
    position: relative;
    text-align: center;
    min-width: 130px;
    -webkit-font-smoothing: antialiased;

    &.secondary {
      color: #000;
      background-color: #f6cd34;
    }

    &.loading {
      background-color: #d7d7d7;
    }

    &:hover {
      &:before {
        background-color: rgba(0, 0, 0, 0.15);
      }
    }

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-radius: 4px;
      transition: all 0.2s linear;
    }
  }
}
</style>
